import React, {useEffect, useState} from 'react';
import {getFileAPI} from '../../../services/admin';
import styles from './ConfirmFilePopUp.module.css';
import {XMarkIcon} from '@heroicons/react/24/outline';

interface ConfirmFilePopUpProps {
    isOpen: boolean;
    onClose: () => void;
    reportId: number;
}

//보고서 PDF 미리보기 팝업
const ConfirmFilePopUp: React.FC<ConfirmFilePopUpProps> = ({isOpen, onClose, reportId}) => {
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            fetchFile();
        } else {
            if (pdfUrl) {
                URL.revokeObjectURL(pdfUrl);
                setPdfUrl(null);
            }
        }
    }, [isOpen, reportId]);

    const fetchFile = async () => {
        try {
            setLoading(true);
            //보고서 파일 조회 API
            const blob = await getFileAPI(reportId);
            //파일 내부 URL 생성
            const url = URL.createObjectURL(blob);
            setPdfUrl(url + '#toolbar=0');
        } catch (error) {
            console.error('Error fetching file:', error);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <>
            <div className={styles.backdrop} onClick={onClose}/>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h2 className={styles.title}>보고서 미리보기</h2>
                    {/*닫기 버튼*/}
                    <button
                        onClick={onClose}
                        className={styles.closeButton}
                        aria-label="Close"
                    >
                        <XMarkIcon className={styles.closeIcon}/>
                    </button>
                </div>

                <div className={styles.content}>
                    {loading && (
                        <div className={styles.loading}>
                            파일을 불러오는 중...
                        </div>
                    )}

                    {pdfUrl && !loading && (
                        // PDF 미리보기
                        <object
                            data={pdfUrl}
                            type="application/pdf"
                            className={styles.pdfViewer}
                        >
                            {/*PDF 미리보기 불가 시 다운로드*/}
                            <p>PDF를 표시할 수 없습니다. <a href={pdfUrl} target="_blank" rel="noopener noreferrer">다운로드</a></p>
                        </object>
                    )}
                </div>
            </div>
        </>
    );
};

export default ConfirmFilePopUp;